import { render, staticRenderFns } from "./proHelpList.vue?vue&type=template&id=cfcb782a&scoped=true"
import script from "./proHelpList.vue?vue&type=script&lang=js"
export * from "./proHelpList.vue?vue&type=script&lang=js"
import style0 from "./proHelpList.vue?vue&type=style&index=0&id=cfcb782a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcb782a",
  null
  
)

export default component.exports